// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__sNs6Y","overlay":"Modal_overlay__pD+CB","inner":"Modal_inner__H4t+H","content":"Modal_content__1BuU-","sm":"Modal_sm__9yH27"};